import {ContentDispatch} from 'framework';
import Flyout from 'go/components/flyoutPanel/FlyoutPanel';
import React from 'react';
import _ from 'lodash';
import {connectDynamic, DynamicComponent} from 'go/components/dynamic/dynamicComponent';
import dynamicValidate from 'go/components/dynamic/dynamicValidate';
import utils from 'go/components/dynamic/layout/reviewPanel/utils';
import {FemaGoModal} from 'app-ui-componentlibrary';
import {compileContent} from 'common/utils';

export class ReviewPanel extends DynamicComponent {
  constructor(props) {
    super(props);
    this.reviewPanelSubmitHandler = this.reviewPanelSubmitHandler.bind(this);
  }

  componentDidUpdate(prevProps) {
    let sections = _.get(this.props, 'config.contents');
    let data = _.cloneDeep(_.get(this.props, 'data.payload', {}));
    data.context = _.cloneDeep(_.get(this.props, 'dynamicComponent.context'));
    data.validationErrors = _.cloneDeep(
      _.get(this.props, 'dynamicComponent.validationErrors')
    );
    if (sections && data) {
      let sectionStatuses = {};
      sections.forEach(
        (section) => (sectionStatuses[section.id] = calculateSectionStatus(section, data))
      );
      if (!_.isEqual(prevProps.sectionStatuses, sectionStatuses)) {
        this.props.saveSectionStatuses(sectionStatuses);
      }
    }
  }

  reviewPanelSubmitHandler = (payload) => {
    if (
      this.props.submitConfig.confirmSubmission &&
      (this.props.submitConfig.disableOnSections || this.validateContent())
    ) {
      // Show modal
      this.setState({
        isConfirmationModalOpen: true,
        payload: payload,
      });
    }
    // don't need to validate if using disabled Submit button pattern:
    else if (this.props.submitConfig.disableOnSections) {
      return this.props.handleSubmit(payload);
    } else if (this.validateContent()) {
      return this.props.handleSubmit(payload);
    }
  };

  validateContent() {
    let validations = [];
    let {contents} = this.props.config;

    contents.forEach((section) => {
      if (section.contents) {
        section.contents.forEach((field) => {
          if (field.validations) {
            field.validations.forEach((validation) => {
              return validations.push(validation);
            });
          }
        });
      }
      if (section.status) {
        return validations.push(...section.status.incomplete);
      }
    });

    return this.validateAllContent({
      contents: contents,
      validations: validations,
    });
  }

  renderModal() {
    const {isConfirmationModalOpen, payload} = this.state;
    const {config, data, fundingOpportunityName} = this.props;
    const submissionVariables = _.get(this.props, 'submissionVariables', {});
    const grantId = data.grantId;

    const modalConfig = _.get(config, 'submitConfig.confirmationModal', {});
    const modalTitle = _.get(modalConfig, 'modalTitle', '');
    const modalContent = compileContent(_.get(modalConfig, 'modalContent', ''), {
      grantId: grantId,
      foName: fundingOpportunityName,
      ...submissionVariables,
    });
    const contents = _.get(modalConfig, 'contents', []);
    return (
      <FemaGoModal
        title={modalTitle}
        buttonText="Confirm"
        open={!!isConfirmationModalOpen}
        confirmAction={() => {
          if (this.props.submitConfig.disableOnSections) {
            this.props.handleSubmit(payload);
          } else if (this.validateContent()) {
            this.props.handleSubmit(payload);
          }
          this.setState({
            isConfirmationModalOpen: false,
          });
          this.props.handleSubmit(payload);
        }}
        cancelAction={() =>
          this.setState({
            isConfirmationModalOpen: false,
          })
        }
        htmlContent={modalContent}
      >
        {_.map(contents, (conf, index) => {
          let config = {
            ...conf,
          };
          return <ContentDispatch key={conf.id || index} config={config} />;
        })}
      </FemaGoModal>
    );
  }

  render() {
    const {config, dynamicComponent, data, setCurrentFieldList, taskContext} = this.props;
    let sections = config.contents;
    let sectionsRendered = _.map(sections, (section) => {
      const status = _.get(this.props, `sectionStatuses.[${section.id}]`);
      const options = _.get(section, 'reviewPanelOptions', {});
      let hideSection = false;
      if (options.conditionalHideRules) {
        _.forEach(options.conditionalHideRules, (rule) => {
          const predicate = _.get(utils, rule.conditionalRender);
          const args = _.map(rule.conditionalRenderArguments, (arg) =>
            _.get(this.props, arg)
          );
          if (rule.conditionalRenderConstants) {
            args.push(...rule.conditionalRenderConstants);
          }
          hideSection = hideSection || (predicate && predicate(...args));
        });
      } else {
        const predicate = _.get(utils, options.conditionalRender);
        const args = _.map(options.conditionalRenderArguments, (arg) =>
          _.get(this.props, arg)
        );
        hideSection = predicate && predicate(...args);
      }
      //end new code
      return {
        id: section.id,
        name: section.name,
        statusIndicator: true,
        status: status,
        hideSection,
        content: (
          <ContentDispatch
            config={section}
            data={data}
            dynamicComponent={dynamicComponent}
            setCurrentFieldList={setCurrentFieldList}
            taskContext={taskContext}
          />
        ),
      };
    });

    let submitButtonConfig = this.props.submitConfig;

    return (
      <React.Fragment>
        {this.renderModal()}
        <Flyout
          sections={sectionsRendered}
          showLabel={config.openButtonLabel}
          hideLabel={config.closeButtonLabel}
          config={config}
          data={data.payload}
          dynamicComponent={dynamicComponent}
          handleSubmit={this.reviewPanelSubmitHandler}
          submitConfig={submitButtonConfig}
        />
      </React.Fragment>
    );
  }
}

const calculateSectionStatus = (section, data) => {
  if (section.status) {
    if (
      dynamicValidate(
        {
          contents: section.contents,
          validations: section.status['complete'],
        },
        data
      )
    ) {
      return 'complete';
    } else {
      if (
        !dynamicValidate(
          {
            contents: section.contents,
            validations: section.status['incomplete'],
          },
          data
        )
      ) {
        return 'incomplete';
      }
      return 'needsAttention';
    }
  }
};

export default connectDynamic(ReviewPanel);
